import { jsPDF } from "jspdf";
import "svg2pdf.js";
import { SHEET_W, SHEET_H } from "./constants";

export async function exportDrawingPdf(
  svgElement: SVGSVGElement,
  filename: string
): Promise<void> {
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  await pdf.svg(svgElement, {
    x: 0,
    y: 0,
    width: SHEET_W,
    height: SHEET_H,
  });

  pdf.save(filename);
}
